import Service from './service'
export var ApiLogMessageType;
(function (ApiLogMessageType) {
  ApiLogMessageType["SYSTEM_LOG"] = "system.log"
})(ApiLogMessageType || (ApiLogMessageType = {}))
export var LogLevel;
(function (LogLevel) {
  LogLevel["DEBUG"] = "debug"
  LogLevel["INFO"] = "info"
  LogLevel["WARNING"] = "warning"
  LogLevel["CRITICAL"] = "critical"
})(LogLevel || (LogLevel = {}))
/**
 * Сервис для логирования
 * @version 0.0.1
 * @since 1.9.0
 */
export default class LogService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
  }
  /**
     * Записать в лог
     *
     * @since 1.9.0
     * @param {string} message - текст сообщения в лог
     * @param {LogLevel} level - тип (уровень) сообщения в лог
     * @memberof LogService
     *
     * @example <caption>Записать в лог</caption>
     * robot.logService.log(message, level)
     */
  log(message, level) {
    this.messageChannel.send({
      type: ApiLogMessageType.SYSTEM_LOG,
      message,
      level,
    })
  }
}
